import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE, BOOKING_STATUS} from '../../../constants';
import * as _ from 'lodash';
import {Bookings, Records} from '../../../helpers/Urls';

import {
  REJECT_BOOKING_COMPLETED,
  ASSIGN_BOOKING_COMPLETED,
  DEACTIVATE_BOOKING_COMPLETED,
  REVIVE_BOOKING_COMPLETED,
  DOCK_BOOKING_COMPLETED,
} from '../../bookings';

export const FETCH_BOOKINGS = 'FETCH_BOOKINGS';
export const FETCH_BOOKINGS_COMPLETED = 'FETCH_BOOKINGS_COMPLETED';
export const FETCH_BOOKINGS_FAILED = 'FETCH_BOOKINGS_FAILED';

export const FETCH_PREFER_PARTNER = 'FETCH_PREFER_PARTNER';
export const FETCH_PREFER_PARTNER_COMPLETED = 'FETCH_PREFER_PARTNER_COMPLETED';
export const FETCH_PREFER_PARTNER_FAILED = 'FETCH_PREFER_PARTNER_FAILED';

export const SEARCH_IN_BOOKING_FALSE = 'SEARCH_IN_BOOKING_FALSE';
export const SEARCH_IN_BOOKING_TRUE = 'SEARCH_IN_BOOKING_TRUE';
export const APPLY_BOOKING_FILTER = 'APPLY_BOOKING_FILTER';
export const CLEAR_BOOKING_FILTER = 'CLEAR_BOOKING_FILTER';

export const RENDER_CHART_DATA = 'RENDER_CHART_DATA';
export const RENDER_CHART_DATA_COMPLETED = 'RENDER_CHART_DATA_COMPLETED';
export const RENDER_CHART_DATA_FAILED = 'RENDER_CHART_DATA_FAILED';

export const FETCH_VENDOR_GRAPH_DATA = 'FETCH_VENDOR_GRAPH_DATA';
export const FETCH_VENDOR_GRAPH_DATA_COMPLETED =
  'FETCH_VENDOR_GRAPH_DATA_COMPLETED';
export const FETCH_VENDOR_GRAPH_DATA_FAILED = 'FETCH_VENDOR_GRAPH_DATA_FAILED';

export const FETCH_INDENT_DATA = 'FETCH_INDENT_DATA';
export const FETCH_INDENT_DATA_COMPLETED = 'FETCH_INDENT_DATA_COMPLETED';
export const FETCH_INDENT_DATA_FAILED = 'FETCH_INDENT_DATA_FAILED';

export const CREATE_INDENT_DATA = 'CREATE_INDENT_DATA';
export const CREATE_INDENT_DATA_COMPLETED = 'CREATE_INDENT_DATA_COMPLETED';
export const CREATE_INDENT_DATA_FAILED = 'CREATE_INDENT_DATA_FAILED';

export const FETCH_PO_MAPPING = 'FETCH_PO_MAPPING';
export const FETCH_PO_MAPPING_COMPLETED = 'FETCH_PO_MAPPING_COMPLETED';
export const FETCH_PO_MAPPING_FAILED = 'FETCH_PO_MAPPING_FAILED';

export const BLOCK_INDENT = 'BLOCK_INDENT';
export const BLOCK_INDENT_COMPLETED = 'BLOCK_INDENT_COMPLETED';
export const BLOCK_INDENT_FAILED = 'BLOCK_INDENT_FAILED';

export const FETCH_INDENT_INITIAL_DATA = 'FETCH_INDENT_INITIAL_DATA';
export const FETCH_INDENT_INITIAL_DATA_COMPLETED =
  'FETCH_INDENT_INITIAL_DATA_COMPLETED';
export const FETCH_INDENT_INITIAL_DATA_FAILED =
  'FETCH_INDENT_INITIAL_DATA_FAILED';

const FETCH_EDIT_INDENT_DATA_START = 'FETCH_EDIT_INDENT_DATA_START';
const FETCH_EDIT_INDENT_DATA_START_COMPLETED =
  'FETCH_EDIT_INDENT_DATA_START_COMPLETED';
const FETCH_EDIT_INDENT_DATA_START_FAILED =
  'FETCH_EDIT_INDENT_DATA_START_FAILED';

export const FETCH_ALL_ORDERS_DATA = 'FETCH_ALL_ORDERS_DATA';
export const FETCH_ALL_ORDERS_DATA_COMPLETED =
  'FETCH_ALL_ORDERS_DATA_COMPLETED';
export const FETCH_ALL_ORDERS_DATA_FAILED = 'FETCH_ALL_ORDERS_DATA_FAILED';

export const ORDER_ACTION = 'ORDER_ACTION';
export const ORDER_ACTION_COMPLETED = 'ORDER_ACTION_COMPLETED';
export const ORDER_ACTION_FAILED = 'ORDER_ACTION_FAILED';

export const FETCH_ALL_ORDERS_SUPORTING_DOC_DATA =
  'FETCH_ALL_ORDERS_SUPORTING_DOC_DATA';
export const FETCH_ALL_ORDERS_SUPORTING_DOC_DATA_COMPLETED =
  'FETCH_ALL_ORDERS_SUPORTING_DOC_DATA_COMPLETED';
export const FETCH_ALL_ORDERS_SUPORTING_DOC_DATA_FAILED =
  'FETCH_ALL_ORDERS_SUPORTING_DOC_DATA_FAILED';

export const UPLOAD_ALL_ORDERS_DOCS = 'UPLOAD_ALL_ORDERS_DOCS';
export const UPLOAD_ALL_ORDERS_DOCS_COMPLETED =
  'UPLOAD_ALL_ORDERS_DOCS_COMPLETED';
export const UPLOAD_ALL_ORDERS_DOCS_FAILED = 'UPLOAD_ALL_ORDERS_DOCS_FAILED';

//indents
export const FETCH_ALL_INDENT_DATA = 'FETCH_ALL_INDENT_DATA';
export const FETCH_ALL_INDENT_DATA_COMPLETED =
  'FETCH_ALL_INDENT_DATA_COMPLETED';
export const FETCH_ALL_INDENT_DATA_FAILED = 'FETCH_ALL_INDENT_DATA_FAILED';

export const ORDER_TASKS_DETAILS = 'ORDER_TASKS_DETAILS';
export const ORDER_TASKS_DETAILS_COMPLETED = 'ORDER_TASKS_DETAILS_COMPLETED';
export const ORDER_TASKS_DETAILS_FAILED = 'ORDER_TASKS_DETAILS_FAILED';

export const INDENT_ORDER_DETAILS = 'INDENT_ORDER_DETAILS';
export const INDENT_ORDER_DETAILS_COMPLETED = 'INDENT_ORDER_DETAILS_COMPLETED';
export const INDENT_ORDER_DETAILS_FAILED = 'INDENT_ORDER_DETAILS_FAILED';

export const INDENT_DOCUMENTS_DETAILS = 'INDENT_DOCUMENTS_DETAILS';
export const INDENT_DOCUMENTS_DETAILS_COMPLETED =
  'INDENT_DOCUMENTS_DETAILS_COMPLETED';
export const INDENT_DOCUMENTS_DETAILS_FAILED =
  'INDENT_DOCUMENTS_DETAILS_FAILED';

export const INDENT_DOCUMENTS_EDIT = 'INDENT_DOCUMENTS_EDIT';
export const INDENT_DOCUMENTS_EDIT_COMPLETED =
  'INDENT_DOCUMENTS_EDIT_COMPLETED';
export const INDENT_DOCUMENTS_EDIT_FAILED = 'INDENT_DOCUMENTS_EDIT_FAILED';

export const REVIVE_INDENT = 'REVIVE_INDENT';
export const REVIVE_INDENT_COMPLETED = 'REVIVE_INDENT_COMPLETED';
export const REVIVE_INDENT_FAILED = 'REVIVE_INDENT_FAILED';

export const CLOSE_INDENT = 'CLOSE_INDENT';
export const CLOSE_INDENT_COMPLETED = 'CLOSE_INDENT_COMPLETED';
export const CLOSE_INDENT_FAILED = 'CLOSE_INDENT_FAILED';

export const FETCH_INDENT_BIDS = 'FETCH_INDENT_BIDS';
export const FETCH_INDENT_BIDS_COMPLETED = 'FETCH_INDENT_BIDS_COMPLETED';
export const FETCH_INDENT_BIDS_FAILED = 'FETCH_INDENT_BIDS_FAILED';

export const UPDATE_INDENT_BIDS = 'UPDATE_INDENT_BIDS';
export const UPDATE_INDENT_BIDS_COMPLETED = 'UPDATE_INDENT_BIDS_COMPLETED';
export const UPDATE_INDENT_BIDS_FAILED = 'UPDATE_INDENT_BIDS_FAILED';

export const ADD_ADHOC_RATE = 'ADD_ADHOC_RATE';
export const ADD_ADHOC_RATE_COMPLETED = 'ADD_ADHOC_RATE_COMPLETED';
export const ADD_ADHOC_RATE_FAILED = 'ADD_ADHOC_RATE_FAILED';
export const ORDER_REFERENCE_DATA = 'ORDER_REFERENCE_DATA';
export const ORDER_REFERENCE_DATA_COMPLETED = 'ORDER_REFERENCE_DATA_COMPLETED';
export const ORDER_REFERENCE_DATA_FAILED = 'ORDER_REFERENCE_DATA_FAILED';

export const ORDER_DRIVER_PHONE = 'ORDER_DRIVER_PHONE';
export const ORDER_DRIVER_PHONE_COMPLETED = 'ORDER_DRIVER_PHONE_COMPLETED';
export const ORDER_DRIVER_PHONE_FAILED = 'ORDER_DRIVER_PHONE_FAILED';

export const ORDER_UPDATE_MANUAL_LOCATION = 'ORDER_UPDATE_MANUAL_LOCATION';
export const ORDER_UPDATE_MANUAL_LOCATION_COMPLETED =
  'ORDER_UPDATE_MANUAL_LOCATION_COMPLETED';
export const ORDER_UPDATE_MANUAL_LOCATION_FAILED =
  'ORDER_UPDATE_MANUAL_LOCATION_FAILED';
export const FETCH_INDENT_ORDERS = 'FETCH_INDENT_ORDERS';
export const FETCH_INDENT_ORDERS_COMPLETED = 'FETCH_INDENT_ORDERS_COMPLETED';
export const FETCH_INDENT_ORDERS_FAILED = 'FETCH_INDENT_ORDERS_FAILED';

export const SUBMIT_ORDER_DETAILS = 'SUBMIT_ORDER_DETAILS';
export const SUBMIT_ORDER_DETAILS_COMPLETED = 'SUBMIT_ORDER_DETAILS_COMPLETED';
export const SUBMIT_ORDER_DETAILS_FAILED = 'SUBMIT_ORDER_DETAILS_FAILED';

export const ALL_ORDER__FILTER = 'ALL_ORDER__FILTER';

export const DELETE_ORDER_SUPPORTING_DOC = 'DELETE_ORDER_SUPPORTING_DOC';
export const DELETE_ORDER_SUPPORTING_DOC_COMPLETED =
  'DELETE_ORDER_SUPPORTING_DOC_COMPLETED';
export const DELETE_ORDER_SUPPORTING_DOC_FAILED =
  'DELETE_ORDER_SUPPORTING_DOC_FAILED';
export const SET_ORDER_TAB_KEY = 'SET_ORDER_TAB_KEY';
export const SET_ORDER_CODE = 'SET_ORDER_CODE';
export const SET_ORDER_TRIP_ID = 'SET_ORDER_TRIP_ID';

export const VERIFY_SUBMIT_TASK_DOCS = 'VERIFY_SUBMIT_TASK_DOCS';
export const VERIFY_SUBMIT_TASK_DOCS_COMPLETED =
  'VERIFY_SUBMIT_TASK_DOCS_COMPLETED';
export const VERIFY_SUBMIT_TASK_DOCS_FAILED = 'VERIFY_SUBMIT_TASK_DOCS_FAILED';
export const DELETE_ADHOC_RATE = 'DELETE_ADHOC_RATE';
export const DELETE_ADHOC_RATE_COMPLETED = 'DELETE_ADHOC_RATE_COMPLETED';
export const DELETE_ADHOC_RATE_FAILED = 'DELETE_ADHOC_RATE_FAILED';

export const FETCH_ORDER_ADJUSTMENT = 'FETCH_ORDER_ADJUSTMENT';
export const FETCH_ORDER_ADJUSTMENT_COMPLETED =
  'FETCH_ORDER_ADJUSTMENT_COMPLETED';
export const FETCH_ORDER_ADJUSTMENT_FAILED = 'FETCH_ORDER_ADJUSTMENT_FAILED';
export const CLEAR_ORDER_ADJUSTMENT = 'CLEAR_ORDER_ADJUSTMENT';

export const SUBMIT_ORDER_ADJUSTMENT = 'SUBMIT_ORDER_ADJUSTMENT';
export const SUBMIT_ORDER_ADJUSTMENT_COMPLETED =
  'SUBMIT_ORDER_ADJUSTMENT_COMPLETED';
export const SUBMIT_ORDER_ADJUSTMENT_FAILED = 'SUBMIT_ORDER_ADJUSTMENT_FAILED';

export const CLEAR_PRODUCT_DATA = 'CLEAR_PRODUCT_DATA';
export const REJECT_INDENT_ORDER_PAYMENT = 'REJECT_INDENT_ORDER_PAYMENT';
export const REJECT_INDENT_ORDER_PAYMENT_COMPLETED =
  'REJECT_INDENT_ORDER_PAYMENT_COMPLETED';
export const REJECT_INDENT_ORDER_PAYMENT_FAILED =
  'REJECT_INDENT_ORDER_PAYMENT_FAILED';

export const HOLD_PAYMENT = 'HOLD_PAYMENT';
export const HOLD_PAYMENT_COMPLETED = 'HOLD_PAYMENT_COMPLETED';
export const HOLD_PAYMENT_FAILED = 'HOLD_PAYMENT_FAILED';

const INITIAL_STATE = {
  isFetching: false,
  hasError: false,
  error: '',
  new_bookings_ids: [],
  accepted_booking_ids: [],
  assigned_booking_ids: [],
  docked_booking_ids: [],
  rejected_booking_ids: [],
  scheduled_booking_ids: [],
  without_driver_booking_ids: [],
  isPreferPartnerLoading: false,
  preferPartnerData: [],
  chartDataObj: {},
  isChartDataFetching: false,
  isVendorGraphData: false,
  vendorGraphData: {},
  isIndentDataFetching: false,
  loadingWarhouseIDs: [],
  loadingWarhouseData: {},
  UnloadingWarhouseIDs: [],
  UnloadingWarhouseData: {},
  loadProcuredByData: {},
  loadProcuredByIds: [],
  productData: {},
  productIds: [],
  isIndentDataCreated: false,
  indentInitialData: {},
  editIndentDataLoading: false,
  editIndentData: {},
  isAllOrdersDataFetching: false,
  allOrdersData: {},
  allOrdersDataIds: [],
  deltaCustomersData: {},
  deltaCustomersIds: [],
  isOrderActionFetching: false,
  isAllOrdersSupportingDocFetched: false,
  allOrdersSupportingDocs: {},
  isOrderSupportingDocUploaded: false,
  blockingIndent: false,
  isAllIndentDataFetching: false,
  allIndentData: {},
  allIndentDataIds: [],
  total_indents: 0,
  fetchOrderDetailsData: false,
  orderDetailsData: {},
  indentDocuments: {},
  isFetchingIndentDocuments: false,
  isUpdatingIndentDocuments: false,
  isFetchingIndentBids: false,
  revivingIndent: false,
  closingIndent: false,
  adhocRateAdded: false,
  isOrderReferenceDataFetched: false,
  isManualLoactionFetched: false,
  isOrderDetailsSubmitted: false,
  isFetchingIndentOrders: false,
  indentOrders: [],
  indentOrderIds: [],
  InActiveVehicle: [],
  IsUnavailableVehicle: [],
  UnApprovedVehicle: [],
  fetchOrderTasks: false,
  orderTasksData: {},
  allOrderFilter: '',
  documentStatusData: {},
  isOrderDocDeleted: false,
  orderTabKey: '1',
  orderCode: null,
  orderTripId: null,
  deleteAdhocRateLoading: false,

  orderAdjustmentData: null,
  loadingAdjustment: false,
  adjustmentError: null,

  submittingAdjustment: false,
  submitError: null,
};

//chart data URL to fetch vendor Graph Data:
export const fetchVendorGraphData = (vendor_name, vendor_period) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_VENDOR_GRAPH_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchVendorGraphDataURL(vendor_name, vendor_period),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_VENDOR_GRAPH_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_VENDOR_GRAPH_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_VENDOR_GRAPH_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const chartData = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: RENDER_CHART_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.chartDataURL(),
        data: {...requestData},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: RENDER_CHART_DATA_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: RENDER_CHART_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: RENDER_CHART_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchPreferPartner = (source, destination) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_PREFER_PARTNER});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchPreferPartnerURL(source, destination),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_PREFER_PARTNER_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_PREFER_PARTNER_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_PREFER_PARTNER_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const searchInput = (searchInput = '') => (dispatch) => {
  if (!searchInput) {
    dispatch({
      type: SEARCH_IN_BOOKING_FALSE,
    });
    return;
  }
  dispatch({
    type: SEARCH_IN_BOOKING_TRUE,
    payload: searchInput,
  });
};

export const fetchBookingByStatus = (bookingStatus, search = '') => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_BOOKINGS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchBookingsByStatus(bookingStatus) + search,
      });
      const {data, status} = response || {};

      if (status) {
        dispatch({
          type: FETCH_BOOKINGS_COMPLETED,
          payload: {...data, bookingStatus},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_BOOKINGS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_BOOKINGS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchAllOrdersData = (tabStatus, page, search) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_ALL_ORDERS_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchAllOrdersDataUrl(tabStatus, page, search),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_ALL_ORDERS_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_ALL_ORDERS_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_ALL_ORDERS_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchAllOrdersSupportingDocData = (tabStatus, recordingID) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_ALL_ORDERS_SUPORTING_DOC_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchAllOrdersSupportingDocDataUrl(
          tabStatus,
          recordingID,
        ),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_ALL_ORDERS_SUPORTING_DOC_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_ALL_ORDERS_SUPORTING_DOC_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_ALL_ORDERS_SUPORTING_DOC_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const uploadAllOrdersDoc = (requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: UPLOAD_ALL_ORDERS_DOCS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.uploadAllOrdersDocURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: UPLOAD_ALL_ORDERS_DOCS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: UPLOAD_ALL_ORDERS_DOCS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: UPLOAD_ALL_ORDERS_DOCS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const orderAction = (
  orderStatus,
  bookingId,
  dateTime,
  tabStatus,
  extraData,
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: ORDER_ACTION});

      const requestData = {
        action: orderStatus,
        booking_id: bookingId,
        date_time: dateTime,
        tab_status: tabStatus,
        ...extraData,
      };

      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.orderActionURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: ORDER_ACTION_COMPLETED,
          payload: {...data, orderStatus},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: ORDER_ACTION_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: ORDER_ACTION_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

const getTabNameFromPath = () => {
  const pathname = window.location.pathname;
  if (pathname.includes('/all-orders/assigned')) {
    return 'assigned';
  } else if (pathname.includes('/all-orders/loading')) {
    return 'loading';
  } else if (pathname.includes('/all-orders/in-transit')) {
    return 'in-transit';
  } else if (pathname.includes('/all-orders/unloading')) {
    return 'unloading';
  } else if (pathname.includes('/all-orders/unloading-done')) {
    return 'closed';
  }
  return '';
};

export const orderReference = (requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    const tab_name = getTabNameFromPath();
    try {
      dispatch({type: ORDER_REFERENCE_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.orderReferenceURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: ORDER_REFERENCE_DATA_COMPLETED,
          payload: {...data, tab_name},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: ORDER_REFERENCE_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: ORDER_REFERENCE_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

const onBookingsFetchedSuccessfully = (state, payload) => {
  const {
    booking_ids = [],
    Counts = {},
    bookingStatus = '',
    filters = {},
  } = payload;
  if (bookingStatus === BOOKING_STATUS.NEW_REQUESTS) {
    return {
      ...state,
      isFetching: false,
      hasError: false,
      new_bookings_ids: booking_ids,
      Counts: {
        ...state.Counts,
        ...Counts,
      },
      searching: '',
      filter: {
        ...filters,
      },
    };
  } else if (bookingStatus === BOOKING_STATUS.ACCEPTED) {
    return {
      ...state,
      isFetching: false,
      hasError: false,
      accepted_booking_ids: booking_ids,
      Counts: {
        ...state.Counts,
        ...Counts,
      },
      searching: '',
      filter: {
        ...filters,
      },
    };
  } else if (bookingStatus === BOOKING_STATUS.ASSIGNED) {
    return {
      ...state,
      isFetching: false,
      hasError: false,
      assigned_booking_ids: booking_ids,
      Counts: {
        ...state.Counts,
        ...Counts,
      },
      searching: '',
      filter: {
        ...filters,
      },
    };
  } else if (bookingStatus === BOOKING_STATUS.DOCKED) {
    return {
      ...state,
      isFetching: false,
      hasError: false,
      docked_booking_ids: booking_ids,
      Counts: {
        ...state.Counts,
        ...Counts,
      },
      searching: '',
      filter: {
        ...filters,
      },
    };
  } else if (bookingStatus === BOOKING_STATUS.SCHEDULED) {
    return {
      ...state,
      isFetching: false,
      hasError: false,
      scheduled_booking_ids: booking_ids,
      Counts: {
        ...state.Counts,
        ...Counts,
      },
      searching: '',
      filter: {
        ...filters,
      },
    };
  } else if (bookingStatus === BOOKING_STATUS.REJECTED) {
    return {
      ...state,
      isFetching: false,
      hasError: false,
      rejected_booking_ids: booking_ids,
      Counts: {
        ...state.Counts,
        ...Counts,
      },
      searching: '',
      filter: {
        ...filters,
      },
    };
  } else if (bookingStatus === BOOKING_STATUS.BOOKING_WITHOUT_DRIVER) {
    return {
      ...state,
      isFetching: false,
      hasError: false,
      without_driver_booking_ids: booking_ids,
      Counts: {
        ...state.Counts,
        ...Counts,
      },
      searching: '',
      filter: {
        ...filters,
      },
    };
  }
};

export const applyFilter = (filter = {}, tripStatus = '') => {
  return (dispatch) => {
    dispatch({
      type: APPLY_BOOKING_FILTER,
      payload: filter,
    });
  };
};

export const clearFilter = (filter = {}) => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_BOOKING_FILTER,
    });
  };
};

export const applyAllOrderFilter = (filter = {}, tripStatus = '') => {
  return (dispatch) => {
    dispatch({
      type: ALL_ORDER__FILTER,
      payload: filter,
    });
  };
};

const filterArray = (entry, array) => {
  const newArray = [...array];
  const index = newArray.indexOf(entry);
  if (index !== -1) {
    newArray.splice(index, 1);
  }
  return newArray;
};

const removeBookingId = (state, payload) => {
  const {booking_id = '', Counts = {}} = payload;
  const {
    new_bookings_ids = [],
    accepted_booking_ids = [],
    assigned_booking_ids = [],
    docked_booking_ids = [],
    rejected_booking_ids = [],
    scheduled_booking_ids = [],
    without_driver_booking_ids = [],
  } = state;
  const newBookingsArray = filterArray(booking_id, new_bookings_ids);
  const acceptedBookingsArray = filterArray(booking_id, accepted_booking_ids);
  const assignedBookingsArray = filterArray(booking_id, assigned_booking_ids);
  const dockedBookingsArray = filterArray(booking_id, docked_booking_ids);
  const rejectedBookingsArray = filterArray(booking_id, rejected_booking_ids);
  const scheduledBookingsArray = filterArray(booking_id, scheduled_booking_ids);
  const withpurDriverBookingsArray = filterArray(
    booking_id,
    without_driver_booking_ids,
  );
  return {
    ...state,
    new_bookings_ids: newBookingsArray,
    accepted_booking_ids: acceptedBookingsArray,
    assigned_booking_ids: assignedBookingsArray,
    docked_booking_ids: dockedBookingsArray,
    rejected_booking_ids: rejectedBookingsArray,
    scheduled_booking_ids: scheduledBookingsArray,
    without_driver_booking_ids: withpurDriverBookingsArray,
    Counts,
  };
};

export const fetchIndentData = (id) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_INDENT_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchIndentDataUrl(id),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_INDENT_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_INDENT_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_INDENT_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const clearIndentProductFilterDropdown = () => ({
  type: CLEAR_PRODUCT_DATA,
});

export const createIndentData = (requestData) => {
  return async (dispatch) => {
    const isEditable = requestData.isEditable;
    const indentId = requestData.indentId;
    if ('isEditable' in requestData) {
      delete requestData.isEditable;
    }
    if ('indentId' in requestData) {
      delete requestData.indentId;
    }

    let response = {};
    try {
      dispatch({type: CREATE_INDENT_DATA});
      response = await doRequest({
        method: isEditable ? REQUEST_TYPE.PUT : REQUEST_TYPE.POST,
        url: Bookings.createIndentDataUrl(isEditable ? indentId : ''),
        data: {...requestData},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: CREATE_INDENT_DATA_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: CREATE_INDENT_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: CREATE_INDENT_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchPOMapping = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_PO_MAPPING});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.fetchPOMappingURL(),
        data: {...requestData},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: FETCH_PO_MAPPING_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_PO_MAPPING_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_PO_MAPPING_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchIndentInitialData = () => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_INDENT_INITIAL_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchIndentInitialDataUrl(),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_INDENT_INITIAL_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_INDENT_INITIAL_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_INDENT_INITIAL_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchEditIndentData = (indentId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_EDIT_INDENT_DATA_START});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchEditIndentDataUrl(indentId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_EDIT_INDENT_DATA_START_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_EDIT_INDENT_DATA_START_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_EDIT_INDENT_DATA_START_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const orderDriverPhone = (requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    const tab_name = getTabNameFromPath();
    try {
      dispatch({type: ORDER_DRIVER_PHONE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.orderDriverPhoneURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: ORDER_DRIVER_PHONE_COMPLETED,
          payload: {...data, tab_name},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: ORDER_DRIVER_PHONE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: ORDER_DRIVER_PHONE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const orderUpdateManualLocation = (requestData) => {
  return async (dispatch) => {
    let response = {};
    const tab_name = getTabNameFromPath();

    try {
      dispatch({type: ORDER_UPDATE_MANUAL_LOCATION});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.orderUpdateManualLocationURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: ORDER_UPDATE_MANUAL_LOCATION_COMPLETED,
          payload: {...data, tab_name},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: ORDER_UPDATE_MANUAL_LOCATION_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: ORDER_UPDATE_MANUAL_LOCATION_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const onAllOrdersActionFetched = (state, payload) => {
  const {
    order_data = {},
    Counts = {},
    tab_status = '',
    order_id = null,
    tab_name = '',
  } = payload;
  const actualOrderId = order_id || Object.keys(order_data)[0];

  let getAllOrdersData = state.allOrdersData;
  let getAllOrdersIds = state.allOrdersDataIds;

  let updatedOrderIds = [];
  let updatedAllOrderData = {};

  updatedOrderIds = getAllOrdersIds.filter((id) => id !== actualOrderId);
  updatedAllOrderData = Object.fromEntries(
    Object.entries(getAllOrdersData).filter(([key]) => !order_data[key]),
  );
  if (
    getAllOrdersIds.includes(Number(actualOrderId)) &&
    getAllOrdersData.hasOwnProperty(actualOrderId)
  ) {
    getAllOrdersData = {
      ...getAllOrdersData,
      [actualOrderId]: {...order_data[actualOrderId]},
    };
  }
  let responseData = order_data[actualOrderId];
  let displayFlagData =
    responseData.display_flag === 'ARRIVED' ||
    responseData.display_flag === 'OUT' ||
    responseData.display_flag === 'IN';
  let individualOrdersData = {};
  let individualOrdersId = [];
  if (
    tab_status === BOOKING_STATUS.ASSIGNED ||
    tab_name === BOOKING_STATUS.ASSIGNED
  ) {
    individualOrdersData =
      tab_status.length > 0 ? updatedAllOrderData : getAllOrdersData;
    individualOrdersId =
      tab_status.length > 0 ? updatedOrderIds : getAllOrdersIds;
  } else if (
    tab_status === BOOKING_STATUS.LOADING ||
    tab_name === BOOKING_STATUS.LOADING
  ) {
    individualOrdersData =
      tab_status.length > 0 ? updatedAllOrderData : getAllOrdersData;
    individualOrdersId =
      tab_status.length > 0 ? updatedOrderIds : getAllOrdersIds;
  } else if (
    tab_status === BOOKING_STATUS.IN_TRANSIT ||
    tab_name === BOOKING_STATUS.IN_TRANSIT
  ) {
    individualOrdersData =
      displayFlagData || tab_status.length == 0
        ? getAllOrdersData
        : updatedAllOrderData;
    individualOrdersId =
      displayFlagData || tab_status.length == 0
        ? getAllOrdersIds
        : updatedOrderIds;
  } else if (
    tab_status === BOOKING_STATUS.UNLOADING ||
    tab_name === BOOKING_STATUS.UNLOADING
  ) {
    individualOrdersData =
      tab_status.length > 0 ? updatedAllOrderData : getAllOrdersData;
    individualOrdersId =
      tab_status.length > 0 ? updatedOrderIds : getAllOrdersIds;
  } else if (
    tab_status === BOOKING_STATUS.UNLOADING_DONE ||
    tab_name === BOOKING_STATUS.UNLOADING_DONE
  ) {
    updatedOrderIds = getAllOrdersIds.filter((id) => id !== actualOrderId);
    updatedAllOrderData = Object.fromEntries(
      Object.entries(getAllOrdersData).filter(
        ([key]) => key !== actualOrderId.toString(),
      ),
    );
    individualOrdersData =
      tab_status.length > 0 ? updatedAllOrderData : getAllOrdersData;
    individualOrdersId =
      tab_status.length > 0 ? updatedOrderIds : getAllOrdersIds;
  }

  return {
    ...state,
    allOrdersData: {...individualOrdersData},
    allOrdersDataIds: [...individualOrdersId],
    Counts: {
      ...state.Counts,
      assigned_orders: Counts.assigned_count,
      loading_orders: Counts.loading_count,
      in_transit_orders: Counts.in_transit_count,
      unloading_orders: Counts.unloading_count,
      unloading_done_orders: Counts.unloading_done_count,
    },
    isOrderActionFetching: false,
    showCurrentTripStatus: responseData?.trip_status,
    hasError: false,
    isOrderDriverPhoneFetched: false,
    isManualLoactionFetched: false,
    isOrderReferenceDataFetched: false,
  };
};

export const fetchAllIndentData = (tabStatus, page, search) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_ALL_INDENT_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchAllIndentDataUrl(tabStatus, page, search),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_ALL_INDENT_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_ALL_INDENT_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_ALL_INDENT_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const closeIndent = (requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: CLOSE_INDENT});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.closeIndentURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: CLOSE_INDENT_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: CLOSE_INDENT_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: CLOSE_INDENT_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const reviveIndent = (requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: REVIVE_INDENT});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.reviveIndentURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: REVIVE_INDENT_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: REVIVE_INDENT_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: REVIVE_INDENT_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const indentOrderDetails = (orderId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: INDENT_ORDER_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.indentOrderDetailsURL(orderId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: INDENT_ORDER_DETAILS_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: INDENT_ORDER_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: INDENT_ORDER_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const orderTasksDetails = (orderId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: ORDER_TASKS_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.orderTasksDetailsURL(orderId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: ORDER_TASKS_DETAILS_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: ORDER_TASKS_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: ORDER_TASKS_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const indentDocumentDetails = (orderId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: INDENT_DOCUMENTS_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.indentOrderDocumentsURL(orderId),
      });

      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: INDENT_DOCUMENTS_DETAILS_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: INDENT_DOCUMENTS_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: INDENT_DOCUMENTS_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const updateIndentDocument = (reqBody) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: INDENT_DOCUMENTS_EDIT});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.indentUpdateOrderDocumentsURL(),
        data: reqBody,
      });

      const {status} = response || {};
      if (status) {
        dispatch({
          type: INDENT_DOCUMENTS_EDIT_COMPLETED,
        });
      } else {
        dispatch({
          type: INDENT_DOCUMENTS_EDIT_FAILED,
        });
      }
    } catch (err) {
      dispatch({
        type: INDENT_DOCUMENTS_EDIT_FAILED,
      });
    }
    return response;
  };
};

export const blockIndent = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: BLOCK_INDENT});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.blockIndentURL(),
        data: {...requestData},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: BLOCK_INDENT_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: BLOCK_INDENT_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: BLOCK_INDENT_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchIndentBids = (indentId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_INDENT_BIDS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchIndentBidsURL(indentId),
      });
      console.log('response --FETCH_INDENT_BIDS--', response);
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: FETCH_INDENT_BIDS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_INDENT_BIDS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_INDENT_BIDS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const updateIndentBid = (requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: UPDATE_INDENT_BIDS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.updateIndentBidURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: UPDATE_INDENT_BIDS_COMPLETED,
          payload: {...data, indentId: requestData?.indent_id},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: UPDATE_INDENT_BIDS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: UPDATE_INDENT_BIDS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const addAdhocRate = (requestData, query = '') => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: ADD_ADHOC_RATE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.addAdhocRateURL(query),
        data: {...requestData},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: ADD_ADHOC_RATE_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: ADD_ADHOC_RATE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: ADD_ADHOC_RATE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const submitOrderDetails = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SUBMIT_ORDER_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.submitOrderDetailsURL(),
        data: {...requestData},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: SUBMIT_ORDER_DETAILS_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: SUBMIT_ORDER_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SUBMIT_ORDER_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchIndentOrders = (indentId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_INDENT_ORDERS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchIndentOrdersURL(indentId),
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: FETCH_INDENT_ORDERS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_INDENT_ORDERS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_INDENT_ORDERS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const deleteOrderSupportingDocs = (value) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DELETE_ORDER_SUPPORTING_DOC});
      response = await doRequest({
        method: REQUEST_TYPE.DELETE,
        url: Bookings.deleteOrderSupportingDocsURL(),
        data: value,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: DELETE_ORDER_SUPPORTING_DOC_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: DELETE_ORDER_SUPPORTING_DOC_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DELETE_ORDER_SUPPORTING_DOC_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const verifysubmitTaskDocs = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: VERIFY_SUBMIT_TASK_DOCS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.verifysubmitTaskDocsURL(),
        data: {...requestData},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: VERIFY_SUBMIT_TASK_DOCS_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: VERIFY_SUBMIT_TASK_DOCS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: VERIFY_SUBMIT_TASK_DOCS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const changeOrdersTab = (tabKey) => {
  return (dispatch) =>
    dispatch({
      type: SET_ORDER_TAB_KEY,
      payload: tabKey,
    });
};

export const setOrderCode = (code) => {
  return (dispatch) =>
    dispatch({
      type: SET_ORDER_CODE,
      payload: code,
    });
};

export const setOrderTripId = (trip_id) => {
  return (dispatch) =>
    dispatch({
      type: SET_ORDER_TRIP_ID,
      payload: trip_id,
    });
};

export const deleteAdhocRate = (payload) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DELETE_ADHOC_RATE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.deleteAdhocRateURL(),
        data: payload,
      });

      const {data, status} = response || {};
      if (status) {
        dispatch({type: DELETE_ADHOC_RATE_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: DELETE_ADHOC_RATE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DELETE_ADHOC_RATE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

// payment.actions.js

export const rejectIndentOrderPayment = (payload) => {
  return async (dispatch) => {
    let response = {};

    try {
      dispatch({type: REJECT_INDENT_ORDER_PAYMENT});

      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.rejectIndentOrderPaymentURL(),
        data: payload,
      });

      const {status, data} = response || {};

      if (status) {
        dispatch({
          type: REJECT_INDENT_ORDER_PAYMENT_COMPLETED,
          payload: data,
        });
      } else {
        dispatch({
          type: REJECT_INDENT_ORDER_PAYMENT_FAILED,
          payload: {
            error: response?.message || 'Submit failed',
          },
        });
      }
    } catch (err) {
      dispatch({
        type: REJECT_INDENT_ORDER_PAYMENT_FAILED,
        payload: {error: err.message},
      });
    }

    return response;
  };
};

export const fetchOrderAdjustment = (sourceOrderId, targetOrderId) => {
  return async (dispatch) => {
    let response = {};

    try {
      dispatch({type: FETCH_ORDER_ADJUSTMENT});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Bookings.fetchOrderAdjustmentURL(sourceOrderId, targetOrderId),
      });
      const {data, status} = response || {};

      if (status) {
        dispatch({
          type: FETCH_ORDER_ADJUSTMENT_COMPLETED,
          payload: data,
        });
      } else {
        dispatch({
          type: FETCH_ORDER_ADJUSTMENT_FAILED,
          payload: {error: response?.message || 'Order not found'},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_ORDER_ADJUSTMENT_FAILED,
        payload: {error: err.message},
      });
    }

    return response;
  };
};

export const clearOrderAdjustment = () => ({
  type: CLEAR_ORDER_ADJUSTMENT,
});

export const submitOrderAdjustment = (payload) => {
  return async (dispatch) => {
    let response = {};

    try {
      dispatch({type: SUBMIT_ORDER_ADJUSTMENT});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.submitOrderAdjustmentURL(),
        data: payload,
      });

      const {status, data} = response || {};

      if (status) {
        dispatch({
          type: SUBMIT_ORDER_ADJUSTMENT_COMPLETED,
          payload: data,
        });
      } else {
        dispatch({
          type: SUBMIT_ORDER_ADJUSTMENT_FAILED,
          payload: {error: response?.message || 'Submit failed'},
        });
      }
    } catch (err) {
      dispatch({
        type: SUBMIT_ORDER_ADJUSTMENT_FAILED,
        payload: {error: err.message},
      });
    }

    return response;
  };
};

export const holdPayment = (payload) => {
  return async (dispatch) => {
    let response = {};

    try {
      dispatch({type: HOLD_PAYMENT});

      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Bookings.holdPaymentURL(),
        data: payload,
      });

      const {status, data} = response || {};

      if (status) {
        dispatch({
          type: HOLD_PAYMENT_COMPLETED,
          payload: data,
        });
      } else {
        dispatch({
          type: HOLD_PAYMENT_FAILED,
          payload: {
            error: response?.message || 'Request failed',
          },
        });
      }
    } catch (err) {
      dispatch({
        type: HOLD_PAYMENT_FAILED,
        payload: {error: err.message},
      });
    }

    return response;
  };
};

export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};
  let updatedIndentIds;
  let updatedAllIndentData;
  switch (type) {
    case RENDER_CHART_DATA:
      return {...state, isChartDataFetching: true};
    case RENDER_CHART_DATA_COMPLETED:
      return {
        ...state,
        isChartDataFetching: false,
        chartDataObj: payload.data,
      };
    case RENDER_CHART_DATA_FAILED:
      return {...state, isChartDataFetching: false};

    case FETCH_BOOKINGS:
      return {
        ...state,
        isFetching: true,
        hasError: false,
        error: '',
      };
    case FETCH_BOOKINGS_COMPLETED:
      return onBookingsFetchedSuccessfully(state, payload);
    case FETCH_BOOKINGS_FAILED:
      return {
        ...state,
        isFetching: false,
        hasError: true,
        new_bookings_ids: [],
        accepted_booking_ids: [],
        assigned_booking_ids: [],
        docked_booking_ids: [],
        rejected_booking_ids: [],
        scheduled_booking_ids: [],
        without_driver_booking_ids: [],
        error: payload.message,
      };

    case FETCH_VENDOR_GRAPH_DATA:
      return {
        ...state,
        isVendorGraphData: true,
      };
    case FETCH_VENDOR_GRAPH_DATA_COMPLETED:
      return {
        ...state,
        isVendorGraphData: false,
        vendorGraphData: payload,
      };
    case FETCH_VENDOR_GRAPH_DATA_FAILED:
      return {
        ...state,
        isVendorGraphData: false,
      };

    case FETCH_PREFER_PARTNER:
      return {
        ...state,
        isPreferPartnerLoading: true,
      };
    case FETCH_PREFER_PARTNER_COMPLETED:
      return {
        ...state,
        isPreferPartnerLoading: false,
        preferPartnerData: payload,
      };
    case FETCH_PREFER_PARTNER_FAILED:
      return {
        ...state,
        isPreferPartnerLoading: false,
      };
    case SEARCH_IN_BOOKING_FALSE:
      return {
        ...state,
        searching: '',
      };
    case SEARCH_IN_BOOKING_TRUE:
      return {
        ...state,
        searching: payload,
      };
    case APPLY_BOOKING_FILTER:
      return {
        ...state,
        filter: payload,
      };
    case CLEAR_BOOKING_FILTER:
      return {
        ...state,
        filter: {},
      };

    case FETCH_INDENT_DATA:
      return {
        ...state,
        isIndentDataFetching: true,
      };
    case FETCH_INDENT_DATA_COMPLETED:
      return {
        ...state,
        isIndentDataFetching: false,
        loadingWarehouseIDs: payload?.loading_warehouse_ids,
        loadingWarehouseData: payload?.loading_warehouse_data,
        unloadingWarehouseIDs: payload?.unloading_warehouse_ids,
        unloadingWarehouseData: payload?.unloading_warehouse_data,
        loadProcuredByIds: payload?.load_procured_by_ids,
        loadProcuredByData: payload?.load_procured_by_data,
        productIds: payload?.product_ids,
        productData: payload?.product_data,
        customerVehicleTypeData: payload?.customer_vehicle_type_data,
        customerVehicleTypeIds: payload?.customer_vehicle_type_ids,
        loadProcuredByData: payload?.load_procured_by_data,
        loadProcuredByID: payload?.load_procured_by_ids,
      };
    case FETCH_INDENT_DATA_FAILED:
      return {
        ...state,
        isIndentDataFetching: false,
      };
    case CLEAR_PRODUCT_DATA:
      return {
        ...state,
        productIds: [],
        productData: {},
      };

    case CREATE_INDENT_DATA:
      return {
        ...state,
        isIndentDataCreated: true,
      };
    case CREATE_INDENT_DATA_COMPLETED:
      return {
        ...state,
        isIndentDataCreated: false,
      };
    case CREATE_INDENT_DATA_FAILED:
      return {
        ...state,
        isIndentDataCreated: false,
      };
    case BLOCK_INDENT:
      return {
        ...state,
        blockingIndent: true,
      };
    case BLOCK_INDENT_COMPLETED: {
      const {booking, Counts = {}, ...updatedIndents} = payload || {};
      const newIndentData = {...state.allIndentData};
      Object.entries(updatedIndents).forEach(([id, indentData]) => {
        // Only process objects that are valid indent entries
        if (
          typeof indentData === 'object' &&
          indentData !== null &&
          indentData.id
        ) {
          if (indentData.status === 'CL') {
            // Remove closed indent
            delete newIndentData[id];
          } else {
            // Otherwise, update/merge indent
            newIndentData[id] = indentData;
          }
        }
      });
      let modifiedIndentData = Object.keys(newIndentData)
        .map(Number)
        .sort((a, b) => b - a);
      return {
        ...state,
        blockingIndent: false,
        allIndentData: newIndentData,
        allIndentDataIds: modifiedIndentData,
        Counts: {
          ...state.Counts,
          ...Counts,
        },
      };
    }
    case BLOCK_INDENT_FAILED:
      return {
        ...state,
        blockingIndent: false,
      };

    case FETCH_INDENT_INITIAL_DATA:
      return {
        ...state,
      };
    case FETCH_INDENT_INITIAL_DATA_COMPLETED:
      return {
        ...state,
        indentInitialData: payload,
      };
    case FETCH_INDENT_INITIAL_DATA_FAILED:
      return {
        ...state,
        indentInitialData: {},
      };
    case FETCH_EDIT_INDENT_DATA_START:
      return {
        ...state,
        editIndentDataLoading: true,
      };
    case FETCH_EDIT_INDENT_DATA_START_COMPLETED:
      return {
        ...state,
        editIndentDataLoading: false,
        editIndentData: payload,
      };
    case FETCH_EDIT_INDENT_DATA_START_FAILED:
      return {
        ...state,
        editIndentDataLoading: false,
      };
    case FETCH_ALL_ORDERS_DATA:
      return {
        ...state,
        isAllOrdersDataFetching: true,
      };
    case FETCH_ALL_ORDERS_DATA_COMPLETED:
      return {
        ...state,
        isAllOrdersDataFetching: false,
        allOrdersData: payload?.order_data || {},
        allOrdersDataIds: payload?.order_ids || [],
        deltaCustomersData: payload?.delta_customer_data || {},
        deltaCustomersIds: payload?.delta_customer_ids || [],
        Counts: {
          ...state.Counts,
          assigned_orders: payload?.Counts?.assigned_count,
          loading_orders: payload?.Counts?.loading_count,
          in_transit_orders: payload?.Counts?.in_transit_count,
          unloading_orders: payload?.Counts?.unloading_count,
          unloading_done_orders: payload?.Counts?.unloading_done_count,
        },
        filter: payload?.filter,
        documentStatusData: payload?.document_status_mapping,
        branch_ids: payload?.branch_ids,
        branch_data: payload?.branch_data,
        fulfilment_type: payload?.fulfilment_type,
      };
    case FETCH_ALL_ORDERS_DATA_FAILED:
      return {
        ...state,
        isAllOrdersDataFetching: false,
      };

    case ORDER_ACTION:
      return {
        ...state,
        isOrderActionFetching: true,
      };

    case ORDER_ACTION_COMPLETED:
      return onAllOrdersActionFetched(state, payload);

    case ORDER_ACTION_FAILED:
      return {
        ...state,
        isOrderActionFetching: false,
      };

    case ORDER_DRIVER_PHONE:
      return {
        ...state,
        isOrderDriverPhoneFetched: true,
      };
    case ORDER_DRIVER_PHONE_COMPLETED:
      return onAllOrdersActionFetched(state, payload);

    case ORDER_DRIVER_PHONE_FAILED:
      return {
        ...state,
        isOrderDriverPhoneFetched: false,
      };

    case ORDER_UPDATE_MANUAL_LOCATION:
      return {
        ...state,
        isManualLoactionFetched: true,
      };
    case ORDER_UPDATE_MANUAL_LOCATION_COMPLETED:
      return onAllOrdersActionFetched(state, payload);

    case ORDER_UPDATE_MANUAL_LOCATION_FAILED:
      return {
        ...state,
        isManualLoactionFetched: false,
      };

    case ORDER_REFERENCE_DATA:
      return {
        ...state,
        isOrderReferenceDataFetched: true,
      };
    case ORDER_REFERENCE_DATA_COMPLETED:
      return onAllOrdersActionFetched(state, payload);
    case ORDER_REFERENCE_DATA_FAILED:
      return {
        ...state,
        isOrderReferenceDataFetched: false,
      };

    case FETCH_ALL_ORDERS_SUPORTING_DOC_DATA:
      return {
        ...state,
        isAllOrdersSupportingDocFetched: true,
      };
    case FETCH_ALL_ORDERS_SUPORTING_DOC_DATA_COMPLETED:
      let orderSupportingDocID = Object.keys(payload.order_data)[0];

      return {
        ...state,
        isAllOrdersSupportingDocFetched: false,
        allOrdersSupportingDocs: payload,
        allOrdersData: {
          ...state.allOrdersData,
          [orderSupportingDocID]: {
            ...state.allOrdersData[orderSupportingDocID],
            ...payload.order_data[orderSupportingDocID],
          },
        },
      };
    case FETCH_ALL_ORDERS_SUPORTING_DOC_DATA_FAILED:
      return {
        ...state,
        isAllOrdersSupportingDocFetched: false,
      };

    case UPLOAD_ALL_ORDERS_DOCS:
      return {
        ...state,
        isOrderSupportingDocUploaded: true,
      };
    case UPLOAD_ALL_ORDERS_DOCS_COMPLETED:
      let orderDataId = Object.keys(payload.order_data)[0];

      return {
        ...state,
        isOrderSupportingDocUploaded: false,
        allOrdersSupportingDocs: payload,
        allOrdersData: {
          ...state.allOrdersData,
          [orderDataId]: {
            ...state.allOrdersData[orderDataId],
            ...payload.order_data[orderDataId],
          },
        },
      };
    case UPLOAD_ALL_ORDERS_DOCS_FAILED:
      return {
        ...state,
        isOrderSupportingDocUploaded: false,
      };

    case VERIFY_SUBMIT_TASK_DOCS:
      return {
        ...state,
        isDocumentsVerified: true,
      };
    case VERIFY_SUBMIT_TASK_DOCS_COMPLETED:
      let currentOrderID = payload.record_id;
      return {
        ...state,
        isDocumentsVerified: false,
        allOrdersData: {
          ...state.allOrdersData,
          [currentOrderID]: {
            ...state.allOrdersData[currentOrderID],
            show_loading_doc_checkbox: payload.show_loading_doc_checkbox,
            document_checkbox_data: {
              ...state.allOrdersData[currentOrderID].document_checkbox_data,
              show_loading_doc_checkbox: payload.show_loading_doc_checkbox,
            },
          },
        },
      };
    case VERIFY_SUBMIT_TASK_DOCS_FAILED:
      return {
        ...state,
        isDocumentsVerified: false,
      };

    //indents
    case FETCH_ALL_INDENT_DATA:
      return {
        ...state,
        isAllIndentDataFetching: true,
      };
    case FETCH_ALL_INDENT_DATA_COMPLETED:
      // Create a copy of filters excluding the "search" key
      const {search, ...filtersWithoutSearch} = payload.filters || {};
      return {
        ...state,
        allIndentsData: payload,
        loadingWarehouseIDs: [],
        loadingWarehouseData: {},
        unloadingWarehouseIDs: [],
        unloadingWarehouseData: {},
        isAllIndentDataFetching: false,
        allIndentData: payload?.indents,
        allIndentDataIds: payload?.indents_id,
        total_indents: payload?.total,
        InActiveVehicle: payload?.inactive_vehicle,
        IsUnavailableVehicle: payload?.is_unavailable_vehicle,
        UnApprovedVehicle: payload?.unapproved_vehicle,
        Counts: {
          ...state.Counts,
          ...payload?.Counts,
        },
        filter: {...filtersWithoutSearch},
      };

    case FETCH_ALL_INDENT_DATA_FAILED:
      return {
        ...state,
        isAllIndentDataFetching: false,
      };
    case REVIVE_INDENT:
      return {
        ...state,
        revivingIndent: true,
      };
    case REVIVE_INDENT_COMPLETED:
      const {indent = {}, indent_id = []} = payload;
      let getAllIndentDataIds = state.allIndentDataIds;
      let getAllIndentData = state.allIndentData;
      updatedIndentIds = getAllIndentDataIds.filter((id) => id !== indent_id);
      updatedAllIndentData = Object.fromEntries(
        Object.entries(getAllIndentData).filter(([key]) => !(key in indent)),
      );
      return {
        ...state,
        revivingIndent: false,
        allIndentData: updatedAllIndentData,
        allIndentDataIds: updatedIndentIds,
        Counts: {
          ...state.Counts,
          ...payload.Counts,
        },
      };
    case REVIVE_INDENT_FAILED:
      return {
        ...state,
        revivingIndent: false,
      };
    case CLOSE_INDENT:
      return {
        ...state,
        closingIndent: true,
      };
    case CLOSE_INDENT_COMPLETED:
      updatedIndentIds = state.allIndentDataIds.filter(
        (id) => id !== payload?.indent_id,
      );
      updatedAllIndentData = Object.fromEntries(
        Object.entries(state.allIndentData).filter(
          ([key]) => !(key in payload?.indent),
        ),
      );
      return {
        ...state,
        closingIndent: false,
        allIndentData: updatedAllIndentData,
        allIndentDataIds: updatedIndentIds,
        Counts: {
          ...state.Counts,
          ...payload.Counts,
        },
      };
    case CLOSE_INDENT_FAILED:
      return {
        ...state,
        closingIndent: false,
      };
    case INDENT_ORDER_DETAILS:
      return {
        ...state,
        fetchOrderDetailsData: true,
      };
    case INDENT_ORDER_DETAILS_COMPLETED:
      return {
        ...state,
        fetchOrderDetailsData: false,
        orderDetailsData: payload,
      };
    case INDENT_ORDER_DETAILS_FAILED:
      return {
        ...state,
        fetchOrderDetailsData: false,
      };
    case ORDER_TASKS_DETAILS:
      return {
        ...state,
        fetchOrderTasks: true,
      };
    case ORDER_TASKS_DETAILS_COMPLETED:
      return {
        ...state,
        fetchOrderTasks: false,
        orderTasksData: payload,
      };
    case ORDER_TASKS_DETAILS_FAILED:
      return {
        ...state,
        fetchOrderTasks: false,
      };
    case INDENT_DOCUMENTS_DETAILS:
      return {
        ...state,
        isFetchingIndentDocuments: true,
      };

    case INDENT_DOCUMENTS_DETAILS_COMPLETED:
      return {
        ...state,
        isFetchingIndentDocuments: false,
        indentDocuments: payload,
      };
    case INDENT_DOCUMENTS_DETAILS_FAILED:
      return {
        ...state,
        isFetchingIndentDocuments: false,
      };

    case INDENT_DOCUMENTS_EDIT:
      return {
        ...state,
        isUpdatingIndentDocuments: true,
      };
    case INDENT_DOCUMENTS_EDIT_COMPLETED:
      return {
        ...state,
        isUpdatingIndentDocuments: false,
      };
    case INDENT_DOCUMENTS_EDIT_FAILED:
      return {
        ...state,
        isUpdatingIndentDocuments: false,
      };

    case FETCH_INDENT_BIDS:
      return {...state, isFetchingIndentBids: true};
    case FETCH_INDENT_BIDS_COMPLETED:
      const bids = payload.bids || {};
      let truckTypeData = {};
      let truckTypeIds = [];

      Object.values(bids).forEach((bid) => {
        const vehicleData = bid?.customer_vehicle_data || {};
        const typeData = vehicleData?.customer_vehicle_type_data || {};
        const typeIds = vehicleData?.customer_vehicle_type_ids || [];

        truckTypeData = {...truckTypeData, ...typeData};
        truckTypeIds = [...new Set([...truckTypeIds, ...typeIds])];
      });

      return {
        ...state,
        isFetchingIndentBids: false,
        bids: payload.bids,
        bidsIds: payload.bids_ids,
        totalBidsCount: payload.bids_count,
        truckTypeData,
        truckTypeIds,
      };
    case FETCH_INDENT_BIDS_FAILED:
      return {...state, isFetchingIndentBids: false};
    case UPDATE_INDENT_BIDS_COMPLETED: {
      const {
        bids = {},
        bids_ids = [],
        bids_count,
        Counts = {},
        indentId,
        ...updatedIndents
      } = payload || {};
      const newIndentData = {...state.allIndentData};
      Object.entries(updatedIndents).forEach(([id, indentData]) => {
        // Only process objects that are valid indent entries
        if (
          typeof indentData === 'object' &&
          indentData !== null &&
          indentData.id
        ) {
          if (indentData.status === 'CL') {
            // Remove closed indent
            delete newIndentData[id];
          } else {
            // Otherwise, update/merge indent
            newIndentData[id] = indentData;
          }
        }
      });
      const updatedBids = bids || {};
      const updatedBidIds = bids_ids || [];

      let modifiedIndentData = Object.keys(newIndentData)
        .map(Number)
        .sort((a, b) => b - a);
      return {
        ...state,
        bids: updatedBids,
        bidsIds: updatedBidIds,
        totalBidsCount: bids_count,
        allIndentData: newIndentData,
        allIndentDataIds: modifiedIndentData,
        Counts: {
          ...state.Counts,
          ...Counts,
        },
      };
    }

    case ALL_ORDER__FILTER:
      return {
        ...state,
        allOrderFilter: payload,
      };

    case ADD_ADHOC_RATE:
      return {...state, adhocRateAdded: true};

    case ADD_ADHOC_RATE_COMPLETED: {
      const {indent_id, indent = {}, tab_status, Counts = {}, filters = {}} =
        payload || {};

      const supplyPrice = indent[indent_id]?.supply_price;

      const getAllIndentData = state.allIndentData || {};
      const getAllIndentDataIds = state.allIndentDataIds || [];
      const indentKey = String(indent_id);
      let updatedIndentData = {
        ...getAllIndentData,
        [indentKey]: indent[indentKey],
      };
      if (tab_status === 'IN' || tab_status === 'CR') {
        let updates = {};
        if (tab_status === 'IN') {
          updates.allIndentData = updatedIndentData;
        }
        if (tab_status === 'CR') {
          if (supplyPrice) {
            updates.allIndentDataIds = getAllIndentDataIds.filter(
              (id) => id !== indent_id,
            );
            updates.allIndentData = Object.fromEntries(
              Object.entries(getAllIndentData).filter(
                ([key]) => key !== indentKey,
              ),
            );
          } else {
            updates.allIndentData = updatedIndentData;
          }
        }
        return {
          ...state,
          adhocRateAdded: false,
          Counts: {...state.Counts, ...Counts},
          filters: {...state.filters, ...filters},
          ...updates,
        };
      }
      return {
        ...state,
        adhocRateAdded: false,
        orderDetailsData: {
          ...state.orderDetailsData,
          adhoc_rate_details: {
            id: payload.adhoc_rate_details?.id,
            booking_id: payload.adhoc_rate_details?.booking_id,
            customer_approval_available:
              payload.adhoc_rate_details?.customer_approval_available,
            customer_approval_required:
              payload.adhoc_rate_details?.customer_approval_required,
            indent_id: payload.adhoc_rate_details?.indent_id,
            rate: payload.adhoc_rate_details?.rate,
            rate_doc_url: payload.adhoc_rate_details?.rate_doc_url,
            rate_type: payload.adhoc_rate_details?.rate_type,
          },
        },
      };
    }

    case ADD_ADHOC_RATE_FAILED:
      return {...state, adhocRateAdded: false};

    case FETCH_INDENT_ORDERS:
      return {
        ...state,
        isFetchingIndentOrders: true,
      };
    case FETCH_INDENT_ORDERS_COMPLETED:
      return {
        ...state,
        isFetchingIndentOrders: false,
        indentOrders: payload?.order_data,
        indentOrderIds: payload?.orders_ids,
      };
    case FETCH_INDENT_ORDERS_FAILED:
      return {
        ...state,
        isFetchingIndentOrders: false,
      };
    case SUBMIT_ORDER_DETAILS:
      return {
        ...state,
        isOrderDetailsSubmitted: true,
      };
    case SUBMIT_ORDER_DETAILS_COMPLETED:
      return {
        ...state,
        isOrderDetailsSubmitted: false,
      };
    case SUBMIT_ORDER_DETAILS_FAILED:
      return {
        ...state,
        isOrderDetailsSubmitted: false,
      };

    case DELETE_ORDER_SUPPORTING_DOC:
      return {
        ...state,
        isOrderDocDeleted: true,
      };

    case DELETE_ORDER_SUPPORTING_DOC_COMPLETED: {
      const orderIdKey = Object.keys(payload.order_data)[0];

      const updatedAllOrdersSupportingDocs = {
        ...state.allOrdersSupportingDocs,
        order_data: {
          ...state.allOrdersSupportingDocs.order_data,
          [orderIdKey]: {
            ...payload.order_data[orderIdKey],
          },
        },
      };
      return {
        ...state,
        isOrderDocDeleted: false,
        allOrdersSupportingDocs: updatedAllOrdersSupportingDocs,
        allOrdersData: {
          ...state.allOrdersData,
          [orderIdKey]: {
            ...state.allOrdersData[orderIdKey],
            ...payload.order_data[orderIdKey],
          },
        },
      };
    }

    case DELETE_ORDER_SUPPORTING_DOC_FAILED:
      return {
        ...state,
        isOrderDocDeleted: false,
      };

    case REJECT_BOOKING_COMPLETED:
    case ASSIGN_BOOKING_COMPLETED:
    case REVIVE_BOOKING_COMPLETED:
    case DOCK_BOOKING_COMPLETED:
      return removeBookingId(state, payload);
    case SET_ORDER_TAB_KEY:
      return {
        ...state,
        orderTabKey: payload,
      };
    case SET_ORDER_CODE:
      return {
        ...state,
        orderCode: payload,
      };
    case SET_ORDER_TRIP_ID:
      return {
        ...state,
        orderTripId: payload,
      };

    case DELETE_ADHOC_RATE:
      return {...state, deleteAdhocRateLoading: true};

    case DELETE_ADHOC_RATE_COMPLETED: {
      const {indent_id, indent = {}, tab_status, Counts = {}, filters = {}} =
        payload || {};

      const getAllIndentData = state.allIndentData || {};
      const getAllIndentDataIds = state.allIndentDataIds || [];
      const indentKey = String(indent_id);
      let updatedIndentData = {
        ...getAllIndentData,
        [indentKey]: indent[indentKey],
      };
      if (tab_status === 'IN' || tab_status === 'CR') {
        let updates = {};
        if (tab_status === 'IN') {
          // updates.allIndentDataIds = getAllIndentDataIds.filter(
          //   (id) => id !== indent_id,
          // );
          // updates.allIndentData = Object.fromEntries(
          //   Object.entries(getAllIndentData).filter(
          //     ([key]) => key !== indentKey,
          //   ),
          // );
          const indentStatus = indent[indentKey]?.status;
          if (indentStatus === 'IN') {
            updates.allIndentData = updatedIndentData;
          } else {
            updates.allIndentDataIds = getAllIndentDataIds.filter(
              (id) => id !== indent_id,
            );
            updates.allIndentData = Object.fromEntries(
              Object.entries(getAllIndentData).filter(
                ([key]) => key !== indentKey,
              ),
            );
          }
        }
        if (tab_status === 'CR') {
          updates.allIndentData = updatedIndentData;
        }
        return {
          ...state,
          deleteAdhocRateLoading: false,
          Counts: {...state.Counts, ...Counts},
          filters: {...state.filters, ...filters},
          ...updates,
        };
      }

      return {
        ...state,
        deleteAdhocRateLoading: false,
        orderDetailsData: {
          ...state.orderDetailsData,
          adhoc_rate_details: {
            id: payload.id,
            booking_id: payload.booking_id,
            customer_approval_available: payload.customer_approval_available,
            customer_approval_required: payload.customer_approval_required,
            indent_id: payload.indent_id,
            rate: payload.rate,
            rate_doc_url: payload.rate_doc_url,
            rate_type: payload.rate_type,
          },
        },
      };
    }

    case DELETE_ADHOC_RATE_FAILED:
      return {...state, deleteAdhocRateLoading: false};

    case FETCH_ORDER_ADJUSTMENT:
      return {
        ...state,
        loadingAdjustment: true,
        adjustmentError: null,
      };

    case FETCH_ORDER_ADJUSTMENT_COMPLETED:
      return {
        ...state,
        loadingAdjustment: false,
        orderAdjustmentData: action.payload,
      };

    case FETCH_ORDER_ADJUSTMENT_FAILED:
      return {
        ...state,
        loadingAdjustment: false,
        orderAdjustmentData: null,
        adjustmentError: action.payload.error,
      };
    case CLEAR_ORDER_ADJUSTMENT:
      return {
        ...state,
        orderAdjustmentData: null,
        loadingAdjustment: false,
        adjustmentError: null,
      };

    case SUBMIT_ORDER_ADJUSTMENT:
      return {
        ...state,
        submittingAdjustment: true,
        submitError: null,
      };

    case SUBMIT_ORDER_ADJUSTMENT_COMPLETED: {
      const {order_level_payments, adjustment_history} = action.payload || {};
      return {
        ...state,
        orderDetailsData: {
          ...state.orderDetailsData,
          order_level_payments: {
            ...state.orderDetailsData?.order_level_payments,
            ...order_level_payments,
          },
          ...(Array.isArray(adjustment_history) ? {adjustment_history} : {}),
        },
        submittingAdjustment: false,
      };
    }

    case SUBMIT_ORDER_ADJUSTMENT_FAILED:
      return {
        ...state,
        submittingAdjustment: false,
        submitError: action.payload.error,
      };

    case REJECT_INDENT_ORDER_PAYMENT:
      return {
        ...state,
        loadingRejectIndentOrderPayment: true,
      };

    case REJECT_INDENT_ORDER_PAYMENT_COMPLETED: {
      const rejectedId = payload?.id;
      const adjustmentHistory = state.orderDetailsData?.adjustment_history;
      return {
        ...state,
        loadingRejectIndentOrderPayment: false,
        orderDetailsData: Array.isArray(adjustmentHistory)
          ? {
              ...state.orderDetailsData,
              adjustment_history: adjustmentHistory.map((row) =>
                String(row.id) === String(rejectedId)
                  ? {...row, show_reject_button: false, status: 'Rejected'}
                  : row,
              ),
            }
          : state.orderDetailsData,
      };
    }

    case REJECT_INDENT_ORDER_PAYMENT_FAILED:
      return {
        ...state,
        loadingRejectIndentOrderPayment: false,
      };

    case HOLD_PAYMENT:
      return {
        ...state,
        loadingHoldPayment: true,
      };

    case HOLD_PAYMENT_COMPLETED:
      return {
        ...state,
        loadingHoldPayment: false,
        orderDetailsData: {
          ...state.orderDetailsData,
          hold_payment_details: {
            ...action.payload.hold_payment_details,
          },
        },
      };

    case HOLD_PAYMENT_FAILED:
      return {
        ...state,
        loadingHoldPayment: false,
      };

    default:
      return state;
  }
};
